import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getData } from "../newApis/dotNetApiMethods";

const getUtilityBillTypes = async () => {
  const response = await getData(ajaxEndpoints.UTILITY_BILL_TYPES);
  return response?.data;
};

export default function useUtilityBillTypes() {
  return useQuery(["getUtilityBillTypes"], getUtilityBillTypes, {
    refetchOnWindowFocus: false,
  });
}
